import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { CACHE_EXPIRATION_TIME } from '@/features/constants';
import { FiltersGrid, Pagination } from '@/features/types';
import {
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { Organization } from './types';

export const organizationsApi = createApi({
  reducerPath: 'organizationsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: `${Config.VITE_API_URL}/organizations`,
  }),
  tagTypes: ['Organizations', 'AvailableOrganizations'],
  keepUnusedDataFor: CACHE_EXPIRATION_TIME,
  endpoints: builder => ({
    getOrganizations: builder.infiniteQuery<
      Organization[],
      FiltersGrid & { representativeId: string },
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/query`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['Organizations'],
    }),
    getAvailableOrganizations: builder.infiniteQuery<
      Pick<Organization, 'id' | 'name'>[],
      FiltersGrid & { representativeId: string },
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: `/available`,
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: () => ['AvailableOrganizations'],
    }),
  }),
});

export const useGetOrganizationsInfiniteQuery = normalizeInfiniteQueryData(
  organizationsApi.useGetOrganizationsInfiniteQuery,
);

export const useGetAvailableOrganizationsInfiniteQuery =
  normalizeInfiniteQueryData(
    organizationsApi.useGetAvailableOrganizationsInfiniteQuery,
  );
